enum SocialMediaService {
  Bluesky = 'BLUESKY',
  Reddit = 'REDDIT',
  Twitter = 'TWITTER',
}

export default SocialMediaService
